import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonToggleOption = {
  label: string;
  value: any;
};

@Component({
  selector: 'app-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonToggleComponent {
  @Input() toggleOptions: ButtonToggleOption[] = [];
  @Input() selectedValue!: any;
  @Output() valueChanged = new EventEmitter<any>();

  public onChange(value: any): void {
    this.valueChanged.emit(value);
  }
}
